import { PageHeader } from "../components/common";
import SimpleCrud from "../components/SimpleCrud";
import { useFetch } from "../lib/api";
import { useT } from "../lib/i18n";
import { money } from "../lib/format";

export default function Technicians() {
  const { t } = useT();
  const { data: countries } = useFetch("/countries");
  const copts = (countries || []).map((c) => ({ value: c.code, label: `${c.name} (${c.code})` }));
  return (
    <div>
      <PageHeader title={t("tech.title")} kicker={t("nav.group.master")} />
      <SimpleCrud testid="technicians" endpoint="/technicians" newLabel={t("tech.new")} defaults={{ currency: "USD", active: true }}
        columns={[{ key: "name", label: t("common.name"), render: (r) => <b>{r.name}</b> }, { key: "country", label: t("common.country") }, { key: "level", label: t("tech.level") },
          { key: "skills", label: t("tech.skills") }, { key: "cost_rate_hour", label: t("tech.rate"), num: true, render: (r) => money(r.cost_rate_hour, r.currency) }]}
        fields={[{ key: "name", label: t("common.name"), required: true }, { key: "email", label: t("cust.email") },
          { key: "country", label: t("common.country"), type: "select", required: true, options: copts }, { key: "level", label: t("tech.level") },
          { key: "skills", label: t("tech.skills"), wide: true }, { key: "cost_rate_hour", label: t("tech.rate"), type: "number" },
          { key: "currency", label: t("q.currency"), type: "select", options: [{ value: "USD", label: "USD" }, { value: "MXN", label: "MXN" }] }]} />
    </div>
  );
}
